<!--
  批量转账
  lovi 2020-06-22
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="$t('transfer.batchTransfer')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="content-wrapper">
      <scroll>
        <div class="transfer">
          <div class="title">
            <template v-if="editFlag">
              <span>
                {{ $t("transfer.added") }}
                ({{ countPeople }}{{ $t("common.persons") }})
              </span>
              <span class="text-blue" @click="editFlag = false">
                {{ $t("common.done") }}
              </span>
            </template>
            <template v-else>
              <span class="text-blue" @click="membersAddFlag = true">
                <van-icon name="add" />{{ $t("transfer.continueAdd") }}
              </span>
              <span class="text-blue" @click="editFlag = true">
                {{ $t("common.edit") }}
              </span>
            </template>
          </div>
          <div class="group-list">
            <van-cell
              v-for="(item, index) in newList"
              :key="index"
              :icon="httpUrl + item.avatar"
              :title="item.username"
              :label="_phoneDispose(item.phone)"
            >
              <van-icon
                v-if="editFlag"
                name="clear"
                @click="clickClear(index)"
                slot="right-icon"
              />
              <van-field
                v-else
                v-model="item.money"
                type="number"
                :formatter="_formatter"
                placeholder="0.00"
              >
                <span slot="right-icon">P</span>
              </van-field>
            </van-cell>
          </div>
        </div>

        <div class="remark">
          <van-field
            v-model="remark"
            rows="2"
            autosize
            type="textarea"
            maxlength="20"
            :placeholder="$t('transfer.addNote20')"
            show-word-limit
          />
        </div>
      </scroll>
    </div>
    <div class="transfer-bottom">
      <span>
        {{ $t("transfer.total") }}<i>{{ countMoney }}P</i>
      </span>
      <van-button type="primary" @click="confirmTransfer" :loading="btnLoading">
        {{ $t("transfer.confirmTransfer") }}
        ({{ countPeople }}{{ $t("common.persons") }})
      </van-button>
    </div>
    <!-- 添加成员 -->
    <transition name="slide">
      <members-add
        v-if="membersAddFlag"
        :membersAddFlag.sync="membersAddFlag"
        :membersInfoFlag.sync="membersInfoFlag"
        :type="1"
        @getAmountData="getAmountData"
      />
    </transition>
    <!-- 成员查询信息 -->
    <transition name="slide">
      <members-info
        v-if="membersInfoFlag"
        :membersAddFlag.sync="membersAddFlag"
        :membersInfoFlag.sync="membersInfoFlag"
        :type="1"
        :data="amountData"
        @getNewPeople="getNewPeople"
      />
    </transition>

    <enter-payPsd
      :payPsdFlag.sync="payPsdFlag"
      :data="payPsdData"
      @getPayPsd="batchTranfer"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MembersAdd from "./group/membersAdd";
import MembersInfo from "./group/membersInfo";
import EnterPayPsd from "@/components/enterPayPsd";
export default {
  props: {
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  components: {
    MembersAdd,
    MembersInfo,
    EnterPayPsd
  },
  data() {
    return {
      newList: [],
      remark: "",
      btnLoading: false,
      countMoney: "0.00",
      countPeople: 0,
      membersAddFlag: false, // 添加成员Flag
      membersInfoFlag: false, // 成员InfoFlag
      amountData: {}, // 成员InfoData
      editFlag: false, // 编辑
      payPsdFlag: false,
      payPsdData: {
        title: this.$t("transfer.transferAmount"),
        money: ""
      }
    };
  },
  created() {
    this.newList = JSON.parse(JSON.stringify(this.list));
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:transferFlag", false);
    },
    clickClear(index) {
      // 删除人
      let vm = this;
      vm.newList.splice(index, 1);
    },
    getAmountData(data) {
      // 获取账号信息
      console.log("amountData", data);
      this.amountData = data;
    },
    getNewPeople() {
      // 获取添加人信息
      let vm = this;
      for (let i = 0; i < vm.newList.length; i++) {
        if (vm.newList[i].user_id == vm.amountData.user_id) {
          vm.$toast(vm.$t("transfer.haveAddedUser"));
          return;
        }
      }
      let obj = JSON.parse(JSON.stringify(vm.amountData));
      obj.money = "";
      vm.newList.push(obj);
      console.log("newList", vm.newList);
    },
    confirmTransfer() {
      // 确认转账
      let vm = this;
      if (!vm.newList.length) {
        vm.$toast(vm.$t("transfer.pleaseAddTransferObject"));
        return;
      }
      for (let key of vm.newList) {
        if (key.money == "" || key.money == 0) {
          vm.$toast(vm.$t("common.enterAmount"));
          return;
        }
      }
      if (Number(vm.countMoney) > Number(vm.userInfo.money_usable)) {
        vm.$dialog
          .confirm({
            message: vm.$t("common.balanceInsufficientRecharge"),
            confirmButtonText: vm.$t("common.rechargeNow"),
            cancelButtonText: vm.$t("common.cancel")
          })
          .then(() => {
            // on confirm
            vm.$router.push({
              path: "/recharge"
            });
          })
          .catch(() => {
            // on cancel
          });
        return;
      }
      vm.payPsdFlag = true;
      vm.payPsdData.money = vm.countMoney;
    },
    batchTranfer(data) {
      // 批量转账
      let vm = this;
      let params = {};
      let obj = {};
      obj.data = vm.newList;
      params.pay_password = data;
      params.remark = vm.remark;
      params.data = JSON.stringify(obj);
      vm.$post("/app/transfer/batchTranfer", params, { loading: true }).then(
        res => {
          console.log("batchTranfer", res);
          let query = { flag: 3, order_id: res.list[0].order_id };
          if (res.list[0].is_batch) {
            query = {
              flag: 3,
              is_batch: res.list[0].is_batch,
              order_id: res.list[0].order_id
            };
          }
          vm.$router.push({
            path: "/detail",
            name: "detail",
            query: query
          });
        }
      );
    }
  },
  watch: {
    newList: {
      handler: function(arr) {
        console.log("newList", arr);
        let vm = this;
        let count = 0;
        for (let i = 0; i < arr.length; i++) {
          count += Number(arr[i].money);
          // if (arr[i].money == "" || arr[i].money == 0) {
          //   vm.$toast("请输入转账金额");
          //   break;
          // }
        }
        vm.countMoney = Number(count).toFixed(2);
        vm.countPeople = arr.length;
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.content-wrapper {
  background: #f4f4f4;
}
.transfer {
  padding: 0 16px;
  background: #fff;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  font-size: 14px;
  span {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.van-icon-add {
      font-size: 20px;
      margin-right: 5px;
    }
  }
}
.group-list {
  /deep/.van-cell {
    position: relative;
    align-items: center;
    padding: 10px 0;
    &::after {
      left: 54px;
    }
    .van-cell__left-icon {
      margin-right: 10px;
      width: 44px;
      height: 44px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100%;
      img {
        width: 44px;
        height: 44px;
        border-radius: 4px;
      }
    }
    .van-cell__value {
      .van-field__control {
        text-align: right;
      }
    }
    .van-icon-clear {
      font-size: 20px;
      color: #cdcdcd;
    }
  }
}
.remark {
  margin-top: 10px;
}
.transfer-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  height: 50px;
  font-size: 14px;
  line-height: 1;
  background: #fff;
  span {
    i {
      font-size: 20px;
    }
  }
  /deep/.van-button {
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    border-radius: 18px;
  }
}
</style>
